<div (click)="deleteItem(item)" class="tag-item" *ngFor="let item of uploader.queue">
    <div class="tag-container">
        <div [title]="item.file.name" class="filename">
            {{item.file.name}}
        </div>
        <img class="delete" src="/assets/images/circle-delete.png" />
    </div>
</div>